import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
const shows = [{
  day: '01',
  venue: 'El Cilantrillo',
  city: 'FL Mall'
}, {
  day: '07',
  venue: 'Sajoma Latin Fusion',
  city: 'Orlando'
}, {
  day: '12',
  venue: 'Blue Martini',
  city: 'Orlando'
}, {
  day: '13',
  venue: 'Fama Gastro Bar',
  city: 'Orlando'
}, {
  day: '14',
  venue: "Turull's Kitchen & Bar",
  city: 'Orlando'
}, {
  day: '21',
  venue: "Turull's Kitchen & Bar",
  city: 'Orlando'
}, {
  day: '27',
  venue: 'Mama Juana',
  city: 'Orlando'
}];
export function Shows() {
  const {
    t
  } = useLanguage();
  return <section id="shows" className="py-24 md:py-32 bg-ink2" data-id="element-159">
      <div className="max-w-5xl mx-auto px-6 lg:px-10" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12 flex items-end justify-between flex-wrap gap-4" data-id="element-161">
          <div data-id="element-162">
            <p className="text-gold text-xs tracking-[0.3em] mb-4" data-id="element-163">
              {t('shows.eyebrow')}
            </p>
            <h2 className="font-display text-4xl md:text-5xl text-cream leading-tight" data-id="element-164">
              {t('shows.title.1')}{' '}
              <span className="italic gold-text" data-id="element-165">{t('shows.title.2')}</span>
            </h2>
          </div>
          <p className="text-cream/50 text-sm" data-id="element-166">{t('shows.subtitle')}</p>
        </motion.div>

        <div className="border-t border-gold/15" data-id="element-167">
          {shows.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="group flex items-center gap-6 md:gap-10 py-6 border-b border-gold/15 hover:bg-gold/5 transition-colors px-2" data-id="element-168">
              <div className="font-display text-3xl md:text-5xl gold-text w-16 md:w-24 shrink-0" data-id="element-169">
                {s.day}
              </div>
              <div className="flex-1" data-id="element-170">
                <div className="font-display text-lg md:text-2xl text-cream group-hover:text-gold-light transition-colors" data-id="element-171">
                  {s.venue}
                </div>
                <div className="text-cream/50 text-sm flex items-center gap-1.5 mt-1" data-id="element-172">
                  <MapPinIcon size={12} data-id="element-173" /> {s.city}
                </div>
              </div>
              <div className="hidden md:block text-xs tracking-[0.3em] text-cream/40 group-hover:text-gold transition-colors" data-id="element-174">
                {t('shows.month')}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}